// extracted by mini-css-extract-plugin
export default {"fieldset":"fieldset_vywYt","starIcon":"starIcon_J9o37","isError":"isError_P04pa","inputs":"inputs_YHGZ5","input":"input_DigHN","isActive":"isActive_ayVMe","isHover":"isHover_Xr85a"};